import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import DatePicker from '../../../../../../../../../../General/DatePicker';
import handleNumericCheck from '../../../../../../../../../../../utils/HandleNumericKeys';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
const AddNewCognitiveStatus = ({ setIsRecordSaved, ...props }) => {
    const { isOpenCognitiveStatus, onClose, CognitiveStatus_Modal, mainCognitiveStatusModal, setMainCognitiveStatusModal, setObservationsData, onDeleteCognitiveStatus, cognitiveStatusDDData } = { ...props }

    let valModal = {}
    let ValidationModal = {
        CognitiveStatusValuesVal: "",
        CognitiveDateVal: "",
    }
    const [cognitiveStatusID, setCognitiveStatusID] = useState();
    const [cognitiveStatusValuesSelected, setCognitiveStatusValuesSelected] = useState(false);
    const [isEdit, setIsEdit] = useState(true)
    // const [selectedCognitiveStatusValues,setSelectedCognitiveStatusValues] = useState([])

    const [cognitiveStatusValidationModal, setCognitiveStatusValidationModal] = useState(ValidationModal)
    const [cognitiveStatusSaveUpdateModal, setCognitiveStatusSaveUpdateModal] = useState({})
    // const [mainCognitiveStatusModal, setMainCognitiveStatusModal] = useState(CognitiveStatus_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onCognitiveStatusSaved, setOnCognitiveStatusSaved] = useState(false)
    // const [del, setDel] = useState(false)
    // const [searchDropdown, setSearchDropdown] = useState(false);
    // const [cognitiveStatusValuesBody, setCognitiveStatusValuesBody] = useState({ "TableName": enumUtil.enumAPITableName.PatientImplantableDevice, "SearchParam": '' })
    const [is, setIs] = useState(false);
    console.log("cognitiveStatusData AddNewProblem", props)
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);


    useEffect(() => {
        // setPracticeID(PracticeID)
        if (props.cognitiveStatusID != null) {
            // setDel(true)
            setCognitiveStatusID(props.mainCognitiveStatusModal.cognitiveStatusID)
        } else {
          if (!onCognitiveStatusSaved) {
            setCognitiveStatusID(0);
            // setDel(false)
          } else {
            // setDel(true)
          }
        }
    }, [cognitiveStatusID])
    useEffect(() => {
        // setMainCognitiveStatusModal(CognitiveStatus_Modal)
        console.log("props.cognitiveStatusID",props.cognitiveStatusID)
            if (!isNull(props.mainCognitiveStatusModal?.CognitiveStatusID)) {
                // setProblemsID(props.cognitiveStatusID)
                if(props?.mainCognitiveStatusModal?.CognitiveStatusID){
                    // setMainCognitiveStatusModal({ 
                    //     ...props?.mainCognitiveStatusModal, 
                    //     // CognitiveStatusID: props?.mainCognitiveStatusModal?.CognitiveStatusID,
                    //     // DiagnosisCode:  props?.mainCognitiveStatusModal?.DiagnosisCode,
                    //     // EncounterProblemID:  props?.mainCognitiveStatusModal?.EncounterProblemID,
                    //     // PatientProblemListID:  props?.mainCognitiveStatusModal?.PatientProblemListID,
                    //     // StartDate:  props?.mainCognitiveStatusModal?.StartDate,
                    //     // Description:  props?.mainCognitiveStatusModal?.DiagnosisDescription,
                    //     // Notes:  props?.mainCognitiveStatusModal?.ProblemNotes,
                    // })
                    if(props?.mainCognitiveStatusModal?.CognitiveStatusValuesID){
                        setIsEdit(false);
                        setCognitiveStatusValuesSelected(true);
                        setIs(true);
                    }
                }
            } else {
            console.log("props.cognitiveStatusID ELSEELSE", props?.mainCognitiveStatusModal)
                setMainCognitiveStatusModal({ 
                    ...CognitiveStatus_Modal, 
                    ...props?.mainCognitiveStatusModal, 
                    CognitiveStatusID: "",
                    // DiagnosisCode:  props?.mainCognitiveStatusModal?.DiagnosisCode, 
                });
                if(props?.mainCognitiveStatusModal?.CognitiveStatusValuesID){
                    setIsEdit(false);
                    setCognitiveStatusValuesSelected(true);
                    setIs(true);
                }
            }
    }, [props?.cognitiveStatusID]);

    const CognitiveStatusValidation = async () => {
        let ValidationModal = {
            CognitiveStatusValuesVal: FormValidator(
                mainCognitiveStatusModal.CognitiveStatusValues,
                enumUtil.enumValidationType.Required,
                'Cognitive Status',
            ),
            CognitiveDateVal: FormValidator(
                mainCognitiveStatusModal.CognitiveDate,
                enumUtil.enumValidationType.Required,
                'Date',
            ),

        }
        await setCognitiveStatusValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // const handleSaveCognitiveStatus = async () => {
    //     await CognitiveStatusValidation()
    //     let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    //     if (validation) {
    //         NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
    //         return
    //     } else {
    //         // CognitiveStatusID
    //         // Deleted
    //         let saveModal = {
    //             // TableName: enumUtil.enumAPITableName.CognitiveStatus,
    //             CognitiveStatusID: cognitiveStatusID,
    //             ...cognitiveStatusSaveUpdateModal,
    //         };

    //         console.log("cognitiveStatusData saveModal 1", cognitiveStatusSaveUpdateModal )
            
    //         const clientRecordIDExist = props?.mainCognitiveStatusModal?.recordNoClient;
    //         let cogStatusID = cognitiveStatusID === 0 ? "" : cognitiveStatusID;
            
    //         // 🔁 Update CognitiveStatus in Observations
    //         setObservationsData(prev => {
    //             const cognitiveStatusList = [...(prev.CognitiveStatus || [])];
    //             console.log("cognitiveStatusData  cognitiveStatusList", cognitiveStatusList)
    //             const encounterLength = cognitiveStatusList.length;

    //             const idExist = cognitiveStatusList.some(
    //                 item => item.CognitiveStatusID === cognitiveStatusID
    //             );
    //             console.log("cognitiveStatusData  cognitiveStatusList idExist", idExist)

    //             const mainViewObj = {
    //                 recordNoClient: String(
    //                     idExist
    //                         ? Number(props?.mainCognitiveStatusModal?.recordNoClient) || 0
    //                         : encounterLength + 1
    //                 ),
    //                 ...props?.mainCognitiveStatusModal,
    //                 ...cognitiveStatusSaveUpdateModal,
    //                 CognitiveStatusID: props?.mainCognitiveStatusModal?.CognitiveStatusID ?? "",
    //                 // CognitiveStatusValuesID: cogStatusID ?? "",
    //                 ...(cognitiveStatusSaveUpdateModal.CognitiveStatusID ? { CognitiveStatusID: cognitiveStatusSaveUpdateModal.CognitiveStatusID } : {}),
    //             };

    //             let updatedList = [...cognitiveStatusList];

    //             console.log("cognitiveStatusData  cognitiveStatusList idExist clientRecordIDExist", clientRecordIDExist)
    //             console.log("cognitiveStatusData  cognitiveStatusList idExist cognitiveStatusID", cognitiveStatusID)
    //             if (clientRecordIDExist) {
    //                 const index = updatedList.findIndex(
    //                     item => String(item.recordNoClient) === String(clientRecordIDExist)
    //                 );
    //                 console.log("cognitiveStatusData  cognitiveStatusList idExist clientRecordIDExist index", index)
    //                 if (index !== -1) {
    //                     updatedList[index] = { ...mainViewObj };
    //                 } else {
    //                     updatedList.push(mainViewObj);
    //                 }

    //             } else if (isNull(cognitiveStatusID)) {
    //                 // ✅ New record, but check if CognitiveStatusValuesID already exists
    //                 const cognitiveStatusValuesID = mainViewObj.CognitiveStatusValuesID;

    //                 console.log("cognitiveStatusData  cognitiveStatusList idExist cognitiveStatusValuesID", cognitiveStatusValuesID)
    //                 const existingIndex = updatedList.findIndex(
    //                     item => item.CognitiveStatusValuesID === cognitiveStatusValuesID
    //                 );

    //                 console.log("cognitiveStatusData  cognitiveStatusList idExist existingIndex", existingIndex)
    //                 console.log("cognitiveStatusData  cognitiveStatusList mainViewObj", mainViewObj)

    //                 if (existingIndex !== -1) {
    //                     // Replace existing record with same CognitiveStatusValuesID
    //                     updatedList[existingIndex] = { ...mainViewObj };
    //                 } else {
    //                     updatedList.push(mainViewObj);
    //                 }

    //             } else if (idExist) {
    //                 updatedList = updatedList.map(item =>
    //                     item.CognitiveStatusValuesID === cogStatusID ? { ...mainViewObj } : item
    //                 );
    //             } else {
    //                 updatedList.push(mainViewObj);
    //             }

    //               console.log("cognitiveStatusData  cognitiveStatusList  updatedList", updatedList)
    //             return {
    //                 ...prev,
    //                 CognitiveStatus: updatedList
    //             };
    //         });

    //         // 💾 SaveProblemsData — do not include recordNoClient
    //         props?.setSaveCognitiveStatusData(prev => {
    //             const idExist = prev.some(item => item.CognitiveStatusID === cognitiveStatusID);
    //             const saveData = {
    //                 ...props?.mainCognitiveStatusModal,
    //                 CognitiveStatusID: props?.mainCognitiveStatusModal?.CognitiveStatusID ?? "",
    //                 CognitiveStatusValuesID: cogStatusID ?? "",
    //                 // PatientID: String(patientID),
    //                 // Acuity: mainProblemsModal.Acuity,
    //                 ...cognitiveStatusSaveUpdateModal,
    //             };

    //             // Remove `recordNoClient` if present
    //             delete saveData.recordNoClient;

    //             return isNull(cognitiveStatusID)
    //                 ? (prev.some(item => item.CognitiveStatusValuesID === saveData.CognitiveStatusValuesID)
    //                     ? prev.map(item =>
    //                         item.CognitiveStatusValuesID === saveData.CognitiveStatusValuesID ? { ...saveData } : item
    //                     )
    //                     : [...prev, saveData]
    //                 )
    //                 : (idExist
    //                     ? prev.map(item =>
    //                         item.CognitiveStatusID === cognitiveStatusID ? { ...saveData } : item
    //                     )
    //                     : [...prev, saveData]
    //                 );
    //         });

    //         onClose();
    //         return;

    //         // setObservationsData();
    //     }
    // }
    const handleSaveCognitiveStatus = async () => {
        await CognitiveStatusValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // let saveData = {
            //     CognitiveStatusID: cognitiveStatusID,
            //     ...cognitiveStatusSaveUpdateModal,
            // };
            let saveData = {
                ...mainCognitiveStatusModal,
                ...cognitiveStatusSaveUpdateModal,
                // recordNoClient: props?.mainCognitiveStatusModal?.recordNoClient,
            };

            // Ensure recordNoClient is set on unsaved documents, reuse if editing existing unsaved doc
            let currRecID = props?.mainCognitiveStatusModal?.CognitiveStatusID
            const isNew = isNull(currRecID) || currRecID === "";

            if (isNew) {
                // If editing an existing unsaved doc, keep its recordNoClient
                if (!saveData.recordNoClient) {
                    // If creating a new unsaved doc (no recordNoClient yet), generate once
                    saveData.recordNoClient = String(Date.now());
                }
            } else {
                // For saved docs, remove recordNoClient before sending to backend
                delete saveData.recordNoClient;
            }

            // const clientRecordIDExist = props?.mainCognitiveStatusModal?.recordNoClient;
            // let cogStatusID = cognitiveStatusID === 0 ? "" : cognitiveStatusID;

            // 🔁 Update CognitiveStatus in Observations
            setObservationsData(prev => {
                const cognitiveStatusList = [...(prev.CognitiveStatus || [])];
                // const encounterLength = cognitiveStatusList.length;

                // const idExist = cognitiveStatusList.some(
                //     item => item.CognitiveStatusID === cognitiveStatusID
                // );

                const mainViewObj = {
                    recordNoClient: saveData.recordNoClient || "",
                    ...props?.mainCognitiveStatusModal,
                    ...cognitiveStatusSaveUpdateModal,
                    CognitiveStatusID: props?.mainCognitiveStatusModal?.CognitiveStatusID ?? "",
                    ...(cognitiveStatusSaveUpdateModal.CognitiveStatusID
                        ? { CognitiveStatusID: cognitiveStatusSaveUpdateModal.CognitiveStatusID }
                        : {}),
                };

                let updatedList = [...cognitiveStatusList];

                if (isNew) {
                    const exists = cognitiveStatusList.some(d => d.recordNoClient === mainViewObj.recordNoClient);
                    updatedList = exists
                        ? cognitiveStatusList.map(d =>
                            d.recordNoClient === mainViewObj.recordNoClient ? mainViewObj : d
                        )
                        : [...cognitiveStatusList, mainViewObj];
                } else {
                    updatedList = cognitiveStatusList.map(d =>
                        d.CognitiveStatusID === currRecID ? mainViewObj : d
                    );
                }

                // if (clientRecordIDExist) {
                //     // Update or insert by recordNoClient
                //     const index = updatedList.findIndex(
                //         item => String(item.recordNoClient) === String(clientRecordIDExist)
                //     );
                //     if (index !== -1) {
                //         updatedList[index] = { ...mainViewObj };
                //     } else {
                //         updatedList.push(mainViewObj);
                //     }
                // } else if (isNull(cognitiveStatusID)) {
                //     // New record, but avoid duplicates by CognitiveStatusValuesID
                //     const cognitiveStatusValuesID = mainViewObj.CognitiveStatusValuesID;
                //     const existingIndex = updatedList.findIndex(
                //         item => item.CognitiveStatusValuesID === cognitiveStatusValuesID
                //     );

                //     if (existingIndex !== -1) {
                //         updatedList[existingIndex] = { ...mainViewObj };
                //     } else {
                //         updatedList.push(mainViewObj);
                //     }
                // } else if (idExist) {
                //     updatedList = updatedList.map(item =>
                //         item.CognitiveStatusValuesID === cogStatusID ? { ...mainViewObj } : item
                //     );
                // } else {
                //     updatedList.push(mainViewObj);
                // }

                return {
                    ...prev,
                    CognitiveStatus: updatedList
                };
            });

            props?.setSaveCognitiveStatusData(prev => {
                let cleanSaveData = { ...saveData };

                if (isNew) {
                    // Check if this unsaved doc already has a recordNoClient
                    if (!cleanSaveData.recordNoClient) {
                        // New unsaved doc, assign new recordNoClient
                        cleanSaveData.recordNoClient = String(Date.now());
                    }
                    // No backend ID yet
                    cleanSaveData.CognitiveStatusID = "";
                } else {
                    // Saved docs: remove recordNoClient before sending to backend
                    delete cleanSaveData.recordNoClient;
                    cleanSaveData.CognitiveStatusID = currRecID ?? "";
                }

                if (isNew) {
                    // Find existing unsaved doc by recordNoClient and update it
                    const existingIndex = prev.findIndex(
                        item => item.recordNoClient === cleanSaveData.recordNoClient
                    );

                    if (existingIndex !== -1) {
                        // Update existing unsaved doc
                        return prev.map((item, i) => (i === existingIndex ? { ...item, ...cleanSaveData } : item));
                    }

                    // Append new unsaved doc
                    return [...prev, cleanSaveData];
                } else {
                    // Saved docs: update by CognitiveStatusID or add if missing
                    const idExist = prev.some(doc => doc.CognitiveStatusID === cleanSaveData.CognitiveStatusID);

                    return idExist
                        ? prev.map(doc =>
                            doc.CognitiveStatusID === cleanSaveData.CognitiveStatusID ? cleanSaveData : doc
                        )
                        : [...prev, cleanSaveData];
                }
            });
            // 💾 SaveProblemsData — do not include recordNoClient
            // props?.setSaveCognitiveStatusData(prev => {
            //     const idExist = prev.some(item => item.CognitiveStatusID === cognitiveStatusID);
            //     const saveDataFinal = {
            //         ...props?.mainCognitiveStatusModal,
            //         CognitiveStatusID: props?.mainCognitiveStatusModal?.CognitiveStatusID ?? "",
            //         CognitiveStatusValuesID: cogStatusID ?? "",
            //         ...cognitiveStatusSaveUpdateModal,
            //     };

            //     delete saveDataFinal.recordNoClient;

            //     return isNull(cognitiveStatusID)
            //         ? (prev.some(item => item.CognitiveStatusValuesID === saveDataFinal.CognitiveStatusValuesID)
            //             ? prev.map(item =>
            //                 item.CognitiveStatusValuesID === saveDataFinal.CognitiveStatusValuesID ? { ...saveDataFinal } : item
            //             )
            //             : [...prev, saveDataFinal]
            //         )
            //         : (idExist
            //             ? prev.map(item =>
            //                 item.CognitiveStatusID === cognitiveStatusID ? { ...saveDataFinal } : item
            //             )
            //             : [...prev, saveDataFinal]
            //         );
            // });

            onClose();
            return;
        }
    };

    const handleChange = (e) => {
        setIs(false);
        let { name, value } = e.target
        let modal = { ...mainCognitiveStatusModal };
        let saveModal = { ...cognitiveStatusSaveUpdateModal }
        modal[name] = value
        setMainCognitiveStatusModal(modal)
        for (var property in CognitiveStatus_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setCognitiveStatusSaveUpdateModal(saveModal)
    }

    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainCognitiveStatusModal };
        let saveModal = { ...cognitiveStatusSaveUpdateModal }
        modal[type] = FormatedDate
        setMainCognitiveStatusModal(modal)
        for (var property in CognitiveStatus_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setCognitiveStatusSaveUpdateModal(saveModal)
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainCognitiveStatusModal };
        if (type === 'client' && !isNull(selectedData) && ![ -1, "-1"].includes(selectedData?.value)) {
            if (name === "CognitiveStatusValues") {
                modal[name] = selectedData.display;
                // cognitiveStatusSaveUpdateModal[name] = selectedData.display + "";
                modal['CognitiveStatusValuesID'] = selectedData.value + "";
                cognitiveStatusSaveUpdateModal['CognitiveStatusValuesID'] = selectedData.value + "";

                setIsEdit(false);
                setCognitiveStatusValuesSelected(true);
            }
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {

            modal[name] = ''
            cognitiveStatusSaveUpdateModal[name] = ''
            if (name === 'CognitiveStatusValues') {
                setCognitiveStatusValuesSelected(false);
                setMainCognitiveStatusModal(prev => ({
                  ...prev,
                  CognitiveStatusValues: "",
                  CognitiveStatusValuesID: ""
                }));
            }
        }
        setMainCognitiveStatusModal(modal)
        return selectedData
    }

    const CognitiveStatusName = () => {
      return (
        <p className="heading">Add New Cognitive Status</p>
      )
    }

    return (
        <Modal show={isOpenCognitiveStatus} onHide={isOpenCognitiveStatus} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {/* {DeleteConfirmation} */}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"CognitiveStatus"} HeaderName={CognitiveStatusName} 
                // isOpenDeleteAlert={isOpenDeleteAlert} 
                // onCloseDelete={onCloseDelete} 
                DeletePopup={""} 
                isClosed={onClose} />

                <div className="">
                    {isEdit ?
                        <div className={`input claims_info search-icon-icdSearch" form-group mb-12 ${cognitiveStatusValidationModal.CognitiveStatusValuesVal ? 'error' : ''}`}>
                            <SuperSearchList
                                type="client"
                                id='CognitiveStatusValues'
                                name='CognitiveStatusValues'
                                searchValue={mainCognitiveStatusModal.CognitiveStatusValues}
                                data={cognitiveStatusDDData}
                                onChange={handleChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                placeholder="Select type..."
                                inputError={cognitiveStatusValidationModal.CognitiveStatusValuesVal}
                            />
                            {cognitiveStatusValidationModal.CognitiveStatusValuesVal}
                        </div> :
                        <>
                            {console.log("cognitiveStatusData", mainCognitiveStatusModal.CognitiveStatusValues && mainCognitiveStatusModal.CognitiveStatusValues !== "Other")}

                            {
                                <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                                    <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>{mainCognitiveStatusModal.CognitiveStatusValues}</span> <span className=''></span></p>
                                    <i className='icon-edit-pencil fs-12' onClick={() => setIsEdit(prev => !prev)}></i>
                                </div>
                            }
                        </>}
                    {cognitiveStatusValuesSelected &&
                        <>
                            <div className="d-flex align-items-end gap-15 mb-12">
                                <div className={`input mb-0 ${cognitiveStatusValidationModal.CognitiveDateVal ? 'error' : ''}`}>
                                    <DatePicker
                                        label="Date"
                                        className={`mb-0`}
                                        value={mainCognitiveStatusModal.CognitiveDate}
                                        handleCalendarChangefunc={date => handleDateChange(date, 'CognitiveDate')} />
                                    {cognitiveStatusValidationModal.CognitiveDateVal}
                                </div>
                            </div>
                            <div className='input' >
                                <label className="pb-3px">Notes</label>
                                <textarea 
                                    rows="3" 
                                    className="form-control"
                                    id='Notes'
                                    name='Notes'
                                    value={mainCognitiveStatusModal.Notes}
                                    onChange={handleChange}
                                />
                            </div>
                        </>}
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={handleSaveCognitiveStatus}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewCognitiveStatus